import {
  Datatable,
  DatatableBody,
  DatatableCell,
  DatatableHead,
  DatatableHeader,
  DatatableRow,
  Skeleton,
} from '@monksflow/monks-ui';
import { TableSkeletonActionsCell, TableSkeletonRow } from '@/shared/ui/data-table';
import { TABLE_COL_WIDTH } from '@/shared/constants';
import { ADMIN_TABLE_STYLES } from '../adminTableStyles';

const PLACEHOLDER_ROWS = 3;

export function WorkspaceProviderWhitelistRulesSkeleton() {
  return (
    <div
      data-testid="workspace-whitelist-rules-skeleton"
      aria-hidden
      className="flex w-full flex-col gap-4"
    >
      <div className="flex items-center justify-between gap-2xl">
        <div className="flex flex-col gap-2xs">
          <Skeleton className="h-5 w-36" />
          <Skeleton className="h-4 w-72" />
        </div>
        <Skeleton className="h-9 w-28 rounded-sm" />
      </div>

      <Datatable className={ADMIN_TABLE_STYLES}>
        <DatatableHeader>
          <DatatableRow>
            <DatatableHead className="w-[40%]">
              <Skeleton className="h-3 w-20" />
            </DatatableHead>
            <DatatableHead>
              <Skeleton className="h-3 w-32" />
            </DatatableHead>
            <DatatableHead className={TABLE_COL_WIDTH.actions} />
          </DatatableRow>
        </DatatableHeader>
        <DatatableBody>
          {Array.from({ length: PLACEHOLDER_ROWS }, (_, index) => (
            <TableSkeletonRow key={index} testId="workspace-whitelist-rules-skeleton-row">
              <DatatableCell>
                <Skeleton className="h-4 w-32" />
              </DatatableCell>
              <DatatableCell>
                <Skeleton className="h-4 w-64" />
              </DatatableCell>
              <TableSkeletonActionsCell />
            </TableSkeletonRow>
          ))}
        </DatatableBody>
      </Datatable>
    </div>
  );
}
